module.exports = __webpack_public_path__ + "img/feather_upload-cloud.74688aca.svg";